module.exports = __webpack_public_path__ + "img/puzzle6.jpg";